
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { Box, GlobalStyles } from '@mui/joy';
import { useEffect, useRef, useState } from 'react';
import { useRouter } from 'next/router';
import { useMediaQuery, useWindowSize } from 'usehooks-ts';
import { useTheme } from '@mui/joy/styles';
import { DefaultLayout } from '../layouts';
import { getPageByUri } from '../queries/pages';
import { getApolloClient } from '../utilities/apolloClient';
import { getNextStaticProps } from '../utilities/getNextStaticProps';
// Page Component
export default function Page() {
    const ref = useRef();
    const router = useRouter();
    const { height } = useWindowSize();
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up('sm').replace('@media ', ''));
    const [queryParamString, setQueryParamString] = useState('');
    function getQueryParamString() {
        const hashes = router.asPath.split('?')[1];
        console.log(router.asPath, hashes);
        let paramString = '';
        if (hashes && hashes.length > 0) {
            paramString = `?${hashes}`;
        }
        return paramString;
    }
    useEffect(() => {
        setQueryParamString(getQueryParamString());
    }, [router.asPath]);
    // Render the page
    return (<>
            <GlobalStyles styles={{
            html: { overflow: 'hidden' },
            body: { overflow: 'hidden' }
        }}/>
            <Box ref={ref} component="iframe" width="100vw" height={height - (matches ? 109 : 63)} style={{ border: 'none' }} src={(process.env.NEXT_PUBLIC_APPLICATION_FORM_URL +
            queryParamString).replace('{lang}', router?.locale || 'en')}/>
        </>);
}
Page.getLayout = (page, props) => (<DefaultLayout noFooter {...props}>
        {page}
    </DefaultLayout>);
async function getStaticProps(ctx) {
    const { locale } = ctx;
    const client = getApolloClient();
    const pageResponse = await getPageByUri(client, '/company', locale);
    return getNextStaticProps(ctx, {
        Page,
        client,
        props: {
            page: pageResponse.data
        }
    });
}

    async function __Next_Translate__getStaticProps__193bbee813a__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/apply-now',
            loaderName: 'getStaticProps',
            loadLocaleFrom: typeof __i18nConfig.loadLocaleFrom === 'function' ? __i18nConfig.loadLocaleFrom : (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__193bbee813a__ as getStaticProps }
  